const firstValue = (...values) => values.find((value) => value !== undefined && value !== null && value !== "") ?? "";

export const getNotificationAppointmentTarget = (notification) => {
  const row = notification && typeof notification === "object" ? notification : {};
  const appointment = row.appointment && typeof row.appointment === "object" ? row.appointment : {};
  const client = appointment.client && typeof appointment.client === "object" ? appointment.client : {};

  return {
    appointmentId: firstValue(row.appointment_id, appointment.id, ""),
    clientId: firstValue(row.client_id, client.id, appointment.client_id, ""),
    showdate: firstValue(appointment.local_start_datetime?.slice(0, 10), row.appointment_date, row.dateof, appointment.dateof, ""),
    showstartdate: firstValue(appointment.local_start_datetime, appointment.showstartdate, appointment.dateof && appointment.start_time ? `${appointment.dateof} ${appointment.start_time}` : "", row.start_datetime, appointment.start_datetime, ""),
    showenddate: firstValue(appointment.local_end_datetime, appointment.showenddate, appointment.dateof && appointment.end_time ? `${appointment.dateof} ${appointment.end_time}` : "", row.end_datetime, appointment.end_datetime, ""),
  };
};
